import React, { Component } from "react";
import withAuthorization from "../withAuthorization";
import { withRouter, Redirect } from "react-router-dom";
import * as resourceTypes from "../../constants/resourceTypes";
import httpreq from "../utils/Api";
import * as apiRoutes from "../../constants/apiRoutes";
import SidebarMenu from "../SidebarMenu";
import Home from "./Home.css";
import * as Resources from "../../constants/resources";

const HomePage = ({ history }) => (
  <div>
    <HomePageComponent history={history} />
  </div>
);

const INITIAL_STATE = {
  selectedCategory: "",
  selectedSubCategory: ""
};

class HomePageComponent extends Component {
  constructor(props) {
    super(props);
    this.props.history.listen((location, action) => {
      // window.scrollTo(0,0);
    });
    this.state = {
      ...INITIAL_STATE
    };

    this.state[resourceTypes.ALL_RESOURCES] = Resources;
    this.state[resourceTypes.SELF_IMPROVEMENT] = Resources.selfImprovement;
    this.state[resourceTypes.ENTREPRENEURSHIP] = Resources.entrepreneurship;
    this.state[resourceTypes.EDUCATION] = Resources.education;
  }

  componentDidMount() {}

  getLinksForSub(links) {
    <div className="card-body">
      <ul className="list-group list-group-flush">
        {links.map((resource, index) => {
          return (
            <li key={index} className="list-group-item text-center">
              <h6 className="text-center"> {resource.title} </h6>
              <p className="text-center">{resource.description} </p>
              <a href={resource.url} target="_blank">
                <button className="btn kinnected-orange">Learn More</button>
              </a>
            </li>
          );
        })}
      </ul>
    </div>;
  }

  render() {
    return (
      <React.Fragment>
        <div className="home">
          <div className="containerWidth" style={{ marginTop: "80px" }}>
            <SidebarMenu
              history={this.props.history}
              allresources={this.state[resourceTypes.ALL_RESOURCES]}
              selfimprovement={this.state[resourceTypes.SELF_IMPROVEMENT]}
              entrepreneurship={this.state[resourceTypes.ENTREPRENEURSHIP]}
              education={this.state[resourceTypes.EDUCATION]}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/landing/Home.js